import { ReactNode } from "react";

interface InputFieldProps {
  label: string;
  value: string | number;
  onChange: (v: string) => void;
  prefix?: string;
  suffix?: string;
  helper?: ReactNode;
  min?: number;
  step?: number;
  type?: "number" | "text";
  placeholder?: string;
}

export function NumberInput({
  label, value, onChange, prefix, suffix, helper, min = 0, step = 0.01, placeholder,
}: InputFieldProps) {
  return (
    <label className="block">
      <span className="label-sm block mb-1.5">{label}</span>
      <div className="relative">
        {prefix && (
          <span className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-500 text-sm pointer-events-none">{prefix}</span>
        )}
        <input
          type="number"
          inputMode="decimal"
          value={value}
          min={min}
          step={step}
          placeholder={placeholder}
          onChange={(e) => onChange(e.target.value)}
          className={`input-field num ${prefix ? "pl-7" : ""} ${suffix ? "pr-12" : ""}`}
        />
        {suffix && (
          <span className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-500 text-sm pointer-events-none">{suffix}</span>
        )}
      </div>
      {helper && <div className="helper-text">{helper}</div>}
    </label>
  );
}

export function SelectField({
  label, value, onChange, options, helper,
}: {
  label: string;
  value: string;
  onChange: (v: string) => void;
  options: { value: string; label: string }[];
  helper?: ReactNode;
}) {
  return (
    <label className="block">
      <span className="label-sm block mb-1.5">{label}</span>
      <select value={value} onChange={(e) => onChange(e.target.value)} className="input-field">
        {options.map((o) => (
          <option key={o.value} value={o.value}>{o.label}</option>
        ))}
      </select>
      {helper && <div className="helper-text">{helper}</div>}
    </label>
  );
}
